import React, { useState } from "react";
import Navbar from "./navbar";
import Sidebar from "./sidebar";
import Footer from "./footer";
import { Box } from "@mui/material";

export default function Layout({ children }) {
  const [open, setOpen] = useState(true);
  const toggleDrawer = () => setOpen((prev) => !prev);

  return (
    <Box sx={{ display: "flex", flexDirection: "row", minHeight: "100vh" }}>
      <Sidebar open={open} />
      <Box sx={{ flexGrow: 1, display: "flex", flexDirection: "column" }}>
        <Navbar open={open} toggleDrawer={toggleDrawer} />
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            px: { xs: 2, md: 2 },
            py: 3,
            mt: "56px",
            backgroundColor: "#ffffffff",
            minHeight: "calc(100vh - 56px - 40px)",
            minWidth: 0,
            overflowX: "hidden",
          }}
        >
          {children}
        </Box>

        <Footer open={open} />
      </Box>
    </Box>
  );
}
